import { render, staticRenderFns } from "./progress-prioritization-row.vue?vue&type=template&id=29645508&"
import script from "./progress-prioritization-row.vue?vue&type=script&lang=js&"
export * from "./progress-prioritization-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports